import { APIModel } from "app/state/api";
import { ApiCallModel } from "app/state/api/interfaces";

export const CreateBookmark: ApiCallModel = {
  ...APIModel(`${process.env.REACT_APP_API}/bookmark`),
};

export const DeleteBookmark: ApiCallModel = {
  ...APIModel(`${process.env.REACT_APP_API}/bookmark/{id}`),
};

export const GetBookmarks: ApiCallModel = {
  ...APIModel(`${process.env.REACT_APP_API}/bookmarks`),
};

export const UpdateBookmark: ApiCallModel = {
  ...APIModel(`${process.env.REACT_APP_API}/bookmark/{id}`),
};

export const CreateAlert: ApiCallModel = {
  ...APIModel(`${process.env.REACT_APP_API}/data-alert`),
};

export const DeleteAlert: ApiCallModel = {
  ...APIModel(`${process.env.REACT_APP_API}/data-alert/{id}`),
};

export const GetAlerts: ApiCallModel = {
  ...APIModel(`${process.env.REACT_APP_API}/data-alerts`),
};
